import React, { useEffect } from "react";
import moment from "moment-timezone";
import { timeSlots } from "../../../common-data/DropdowData.js";
import {
  getBCAPendingIcon,
  // memberTypeOptions
} from "../MemberReportMocks.js";
import { FORMATTED_TODAY_DATE_YYYYMMDD } from "../../../common-data/Converts.js";

const MemberReportFilter = ({ allFilters, setAllFilters }) => {
  const currentMoment = moment().tz("Asia/Kolkata");
  const currentHour = currentMoment.hour();
  const currentDate = currentMoment.format("YYYY-MM-DD");

  const currentSlotIndex = Math.max(0, currentHour - 5);

  const isToday = allFilters.selectedDate === currentDate;

  const effectiveCurrentSlotIndex = isToday ? currentSlotIndex : -1;

  const selectedCheckinTimes = Array.isArray(allFilters.selectedCheckinTimes)
    ? allFilters.selectedCheckinTimes
    : [];

  const getFilteredTimeSlots = () => {
    if (isToday) {
      return timeSlots.filter((_, index) => index <= currentSlotIndex);
    }
    return timeSlots;
  };

  const filteredTimeSlots = getFilteredTimeSlots();

  const handleDateChange = (event) => {
    const selectedDate = event.target.value;
    setAllFilters((prev) => ({
      ...prev,
      selectedDate: selectedDate,
      selectedCheckinTimes: [],
    }));
  };

  const handleSlotClick = (slot, index) => {
    const isSelected = selectedCheckinTimes.some(
      (selected) => selected.value === slot.value
    );

    if (isSelected) {
      const updatedSelection = selectedCheckinTimes.filter(
        (selected) => selected.value !== slot.value
      );
      setAllFilters((prev) => ({
        ...prev,
        selectedCheckinTimes: updatedSelection,
      }));
    } else {
      const slotWithIndex = { ...slot, index };
      setAllFilters((prev) => ({
        ...prev,
        selectedCheckinTimes: [...selectedCheckinTimes, slotWithIndex],
      }));
    }
  };

  // const handleMemberTypeClick = (memberType) => {
  //   const isSelected =
  //     allFilters.selectedMemberType?.value === memberType.value;

  //   if (isSelected) {
  //     setAllFilters((prev) => ({
  //       ...prev,
  //       selectedMemberType: "",
  //     }));
  //   } else {
  //     setAllFilters((prev) => ({
  //       ...prev,
  //       selectedMemberType: memberType,
  //     }));
  //   }
  // };

  useEffect(() => {
    if (!allFilters.selectedDate) {
      setAllFilters((prev) => ({
        ...prev,
        selectedDate: FORMATTED_TODAY_DATE_YYYYMMDD,
      }));
    }
  }, [allFilters.selectedDate, setAllFilters]);

  return (
    <section
      className="mr-timeslot"
      role="group"
      aria-label="Date and time slot selector"
    >
      <div className="mr-timeslot__date-section">
        <div className="mr__dateslot-section">
          <header className="mr-timeslot__header">
            {getBCAPendingIcon()}
            <h3 className="mr-timeslot__title">Time Slot</h3>
          </header>
        </div>

        <div className="mr-timeslot__right-filters">
          {/* <div className="mr-member-type-tabs">
            {memberTypeOptions.map((memberType) => {
              const isSelected =
                allFilters.selectedMemberType?.value === memberType.value;
              return (
                <button
                  key={memberType.value}
                  className={`mr-member-type-tab ${
                    isSelected ? "mr-member-type-tab--selected" : ""
                  }`}
                  type="button"
                  onClick={() => handleMemberTypeClick(memberType)}
                  aria-pressed={isSelected}
                  title={`${memberType.description} - ${memberType.label}`}
                >
                  {memberType.icon}
                  <span className="mr-member-type-label">
                    {memberType.label}
                  </span>
                </button>
              );
            })}
          </div> */}

          <input
            id="selectedDate"
            type="date"
            value={allFilters.selectedDate || FORMATTED_TODAY_DATE_YYYYMMDD}
            onChange={handleDateChange}
            className={`mr-timeslot__date-input ${
              allFilters.selectedDate ? "date-has-value" : ""
            }`}
            max={currentDate}
          />
        </div>
      </div>

      <div
        className="mr-timeslot__scroller"
        tabIndex={0}
        aria-label="Available time slots"
      >
        <div className="mr-timeslot__list">
          {filteredTimeSlots.map((slot, index) => {
            const isSelected = selectedCheckinTimes.some(
              (selected) => selected.value === slot.value
            );
            const isCurrent = index === effectiveCurrentSlotIndex;

            return (
              <button
                key={index}
                className={`mr-timeslot__btn ${
                  isSelected ? "is-selected" : ""
                } ${isCurrent ? "is-current" : ""}`}
                type="button"
                aria-pressed={isSelected}
                aria-current={isCurrent ? "time" : undefined}
                data-slot-id={index}
                aria-label={`${isSelected ? "Selected: " : ""}${
                  isCurrent ? "Now: " : ""
                }${slot.label}`}
                onClick={() => handleSlotClick(slot, index)}
              >
                {slot.label}
                {isCurrent && (
                  <span className="mr-timeslot__now" aria-hidden="true">
                    <span className="mr-timeslot__now-ping" />
                    <span className="mr-timeslot__now-dot" />
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MemberReportFilter;
